import { injectCustomerApi } from '@delmonicos/shared-sdk/libs/emsp/src/clients/redux/back-office/customer.service';
import { baseApi } from '@service/base.api';

export const customerApi = injectCustomerApi(baseApi);

export const {
  useGetCustomersPaginatedQuery,
  useGetCustomerQuery,
  useGetLockStatusQuery,
  useLockCustomerMutation,
  useUnlockCustomerMutation,
  useSyncSubscriptionMutation,
} = customerApi;
